export default __webpack_public_path__ + "static/media/tk_seed_check.7c4277ca.png";